/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';

import { Container } from './styles';

export default function ErrorText(props) {
  return (
    <Container>
      <span>{props.children}</span>
    </Container>
  );
}
